module.exports = __webpack_public_path__ + "img/booking.7d3e4c31.png";